<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="toggleFilter('search')" v-focus>
			<div class="button action input-go" @click="toggleFilter('search')"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">

		<div v-if="showDetail">
			<div class="button action" @click="saveItem()">Save Supplier</div>
			<div v-if="!creatingSupplier" :class="['button', listDetail.client_id == getClientId ? 'neutral' : 'disabled']" @click="showDeactivateModal = true">Deactivate Supplier</div>
			<div class="divider"></div>
			<div class="button neutral" @click="backToList()">Back to List</div>
		</div>

		<div v-else>
			<label>Supplier Type</label>
			<select v-model="filters.supplier_type_id" @change="toggleFilter('supplier_type_id')">
				<option value="">All</option>
				<option v-for="supplierType in supplierTypes" :value="supplierType.supplier_type_id">{{ supplierType.description }}</option>
			</select>

			<ul class="checkbox-group">
				<li>
					<span :class="['pointer', 'far', filters.internal_use_only ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('internal_use_only')"></span>
					<label>Hidden</label>
				</li>
				<li v-if="!getAdministratorFlag">
					<span :class="['pointer', 'far', filters.client ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('client')"></span>
					<label>Not System</label>
				</li>
				<li v-if="getAdministratorFlag">
					<span :class="['pointer', 'far', filters.expired_ffl ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('expired_ffl')"></span>
					<label>Expired FFL</label>
				</li>
				<li v-if="getAdministratorFlag">
					<span :class="['pointer', 'far', filters.missing_ffl ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('missing_ffl')"></span>
					<label>Missing FFL Expiration</label>
				</li>
			</ul>
			<div class="divider"></div>
			<div class="button neutral" @click="clearFilters(1)">Clear Filters</div>
			<div v-if ="getAdministratorFlag" class="button action" @click="addSupplier()">Add Supplier</div> 
			<div class="divider"></div>
			<div :class="['extra-menu-item', { disabled: gettingExport }]" @click="doExport()">Export List</div>
			<div class="message">{{ exportMessage }}</div>
			<div v-if="getDevEnvironment" class="extra-menu-item" @click="getList()">Reload List</div>
		</div>
	</div>

	<div v-if="!showDetail" class="list">
	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>
	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list left">Supplier</th>
					<th class="list left">Type</th>
					<th class="list left">FFL Number</th>
					<th class="list left">FFL Expires</th>
				</tr>
			</thead>
			<tr v-for="(item, index) in list" class="clickable-list-item" @click="getItem(item)">
				<td class="list left">
					{{ item.name }}<br>
					{{ item.address_1 }}<br>
					{{ item.city }}, {{ item.state }} {{ item.zip_code }}
				</td>
				<td class="list left">
					{{ item.supplier_type_code.capitalizeWords() }}
				</td>
				<td class="list left">
					{{ item.ffl_number }}<br>
				</td>
				<td class="list left">
					{{ item.ffl_date_expires ? $moment(item.ffl_date_expires).format('MM/DD/YYYY') : '' }}
				</td>
			</tr>
		</table>

	</div>

    <div v-if="showDetail" class="detail">
		<div class="two-columns" style="grid-template-columns: 1.5fr 1fr; align-items: start;">
			<div>
				<label>Supplier Type</label>
				<select v-model="listDetail.supplier_type_id" :disabled="!userCanEdit">
					<option value="">Select...</option>
					<option v-for="supplierType in supplierTypes" :value="supplierType.supplier_type_id">{{ supplierType.description }}</option>
				</select>
				<div class="three-columns">
					<div>
						<label>First Name</label>
						<input type="text" v-model="listDetail.first_name" :disabled="!userCanEdit">
					</div>
					<div>
						<label>Middle Name</label>
						<input type="text" v-model="listDetail.middle_name" :disabled="!userCanEdit">
					</div>
					<div>
						<label>Last Name</label>
						<input type="text" v-model="listDetail.last_name" :disabled="!userCanEdit">
					</div>
				</div>
				<label>Company Name</label>
				<input type="text" v-model="listDetail.company_name" :disabled="!userCanEdit">
				<label>Address</label>
				<input type="text" v-model="listDetail.address_1" :disabled="!userCanEdit">
				<label>Address 2</label>
				<input type="text" v-model="listDetail.address_2" :disabled="!userCanEdit">
				<div class="two-columns">
					<div>
						<label>City</label>
						<input type="text" v-model="listDetail.city" :disabled="!userCanEdit">
					</div>
					<div class="two-columns">
						<div>
							<label>State</label>
							<state-select type="text" :selectedState="listDetail.state" :showAbbr="false" :disabled="!userCanEdit" placeHolder="Select..." @updateSelected="updateSelectedState"></state-select>
						</div>
						<div>
							<label>Zip Code</label>
							<input type="text" v-model="listDetail.zip_code" :disabled="!userCanEdit">
						</div>
					</div>
				</div>
				<div class="two-columns">
					<div>
						<label>FFL Number</label>
						<input type="text" v-model="listDetail.ffl_number" :disabled="!userCanEdit">
					</div>
					<div>
						<label class="full">FFL Expires</label>
						<input type="date" v-model="listDetail.ffl_date_expires" :disabled="!userCanEdit" style="width: 10em;">
					</div>
				</div>

				<div v-if="listDetail.ffl_number">
					<p v-if="!listDetail.ffl_date_expires">This FFL is expired or missing an expiration date.</p>
					<p v-else-if="listDetail.ffl_date_expires < today">This FFL is expired.</p>
					<p v-if="listDetail.parsed_ffl && listDetail.parsed_ffl.ffl_number">This is the most updated information we have from <a href="https://www.atf.gov/firearms/listing-federal-firearms-licensees" target="_blank">https://atf.gov</a>  for this FFL.<br>You can do an FFL EZ Check to see if there is more recent info.</p>
					<div :class="['button', loading ? 'disabled' : 'neutral', 'small']" @click="doEZCheck()">Do FFL EZ Check</div>
				</div>

			</div>
			<div v-if="getAdministratorFlag" style="margin: 0 0 0 2em;">
				<div style="margin: 1em 0;">
					<!-- <b>{{ receivedList.length }} Clients Using This Supplier</b>
					<div class="list">
					    <table class="data-list" cellpadding="0" cellspacing="0">
							<tr v-for="(receipt, index) in receivedList" class="clickable-list-item" @click="$router.push('/inventory/receive-inventory/' + receipt.inventory_receipt_id)">
								<td class="list left">{{ receipt.company_name }}</td>
							</tr>
						</table>
					</div> -->
				</div>
			</div>
			<div v-else style="margin: 0 0 0 2em;">
				<div class="two-columns">
					<div>
						<label class="full">Total Units Received</label>
						<b>{{ detailTotals.total_received || '0' }}</b>
					</div>
					<div>
						<label class="full">Total Received Cost</label>
						<b>{{ $formatCurrency(detailTotals.total_cost_received) }}</b>
					</div>
				</div>
				<div v-if="receivedList.length > 0" style="margin: 1em 0;">
					<b>Most Recent Inventory Receipts</b>
					<div class="list">
					    <table class="data-list" cellpadding="0" cellspacing="0">
							<thead>
								<tr>
									<th class="list left">Date</th>
									<th class="list left">Reference</th>
									<th class="list right">Total Cost</th>
								</tr>
							</thead>
							<tr v-for="(receipt, index) in receivedList" class="clickable-list-item" @click="$router.push('/inventory/receive-inventory/' + receipt.inventory_receipt_id)">
								<td class="list left">{{ receipt.receipt_date }}</td>
								<td class="list left">{{ receipt.order_reference }}</td>
								<td class="list right">{{ $formatCurrency(receipt.total_cost) }}</td>
							</tr>
						</table>
					</div>
				</div>
				<div v-if="logbooksReceivedList.length > 0" style="margin: 1em 0;">
					<b>Most Recent Logbook Receipts</b>
					<div class="list">
					    <table class="data-list" cellpadding="0" cellspacing="0">
							<thead>
								<tr>
									<th class="list left">Date</th>
									<th class="list left">Serial Number</th>
									<th class="list left">Sequence</th>
								</tr>
							</thead>
							<tr v-for="(receipt, index) in logbooksReceivedList" class="clickable-list-item" @click="$router.push('/logbooks/list?id=' + receipt.ffl_log_book_entry_id)">
								<td class="list left">{{ receipt.receipt_date }}</td>
								<td class="list left">{{ receipt.serial_number }}</td>
								<td class="list left">{{ receipt.ffl_log_book_code }}-{{ receipt.sequence_number }}</td>
							</tr>
						</table>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div v-if="showEZCheckModal" class="modal">
		<div class="inner">
			<h2>FFL EZ Check</h2>
			<div class="content" style="min-width: 30em; min-height: 10em;">
				<div v-if="loading" class="loading">
					<p>Contacting FFL EZ Check...</p>
					<i class="fa fa-spinner fa-spin"></i>
				</div>
				<div v-else-if="fflEZCheckResult">
					<p>Here's the info we found from FFL EZ Check. This supplier has been updated with this information.</p>
					<div v-html="fflEZCheckResult"></div>
				</div>
				<div v-else class="message center">{{ fflEZCheckMessage }}</div>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showEZCheckModal = false">Close</div>
			</div>
		</div>
	</div>

	<div v-if="showDeactivateModal" class="modal">
		<div class="inner">
			<h2>Deactivate Supplier</h2>
			<div class="content">
				<p v-if="listDetail.client_id == getClientId">
					Are you sure you want to deactivate this supplier? This will prevent it from being used in new receipts, but will not affect existing receipts.
				</p>
				<p v-else>This supplier belongs to the system and cannot be deactivated.</p>
			</div>
			<div class="controls">
				<div class="button cancel spaced" @click="showDeactivateModal = false">Cancel</div>
				<div v-if="listDetail.client_id == getClientId" class="button neutral spaced" @click="deactivateSupplier()">Yes, Deactivate</div>
			</div>
		</div>
	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

	<message-modal v-if="message" :message="message" :loading="loading || saving" :errorStatus="messageStatus" :timeout="messageTimeout" @dismiss="message = ''" />

	<!-- <help-popup :helpLink="{163:'Calibers'}" :tours="false"></help-popup> -->

</div>

</template>

<script>
//import HelpPopup from '@/components/HelpPopup.vue'
import LabelRequired from '@/components/LabelRequired.vue'
import StateSelect from '@/components/StateSelect.vue'

export default {
	name: 'suppliers',
    components: {
        'label-required': LabelRequired,
        'state-select': StateSelect
		//'help-popup': HelpPopup
    },
	data() {
		return {
			client_id: '',
            loading: true,
			message: '',
			messageTimeout: 0,
			messageStatus: '',
			filters: {},
			supplierTypes: [],
			list: [],
			mergeList: [],
			paging: {},
			gettingExport: false,
			listDetail: {},
			detailTotals: {},
			receivedList: [],
			logbooksReceivedList: [],
			exportMessage: '',
			exporting: false,
			saving: false,
			showDetail: false,
			//listDetail: {},
			showDeactivateModal: false,
			showEZCheckModal: false,
			fflEZCheckResult: '',
			fflEZCheckMessage: '',
			today: new Date().toISOString().substr(0, 10), 
			creatingSupplier: false, 
			newSupplierDetail: null, 
			previousDetail: null
		}
	},
	created() {
		this.getSupplierTypes()
		this.clearFilters(true)
		console.log(this.today)
	},
	computed: {
		userCanEdit() {
			return this.listDetail.client_id == this.client_id || this.getAdministratorFlag
		}
	},
	methods: {
		clearFilters(getList) {
			this.filters = {
				page: 1,
				search_term: '',
				merge_search_term: '',
				supplier_type_id: '',
				internal_use_only: 0,
				inactive: 0,
				do_export: 0, 
				expired_ffl: 0, 
				missing_ffl: 0
			}
			if (getList) {
				this.getList()
			}
		},
		getSupplierTypes() {
			this.apiCall({ destination: 'get_list_inventory_supplier_types' }).then(obj => {
				this.supplierTypes = obj.supplier_types
			})
		},
		getList() {
			this.loading = true
			if (this.filters.do_export) {
				this.message = 'Generating CSV for ' + this.paging.total_items + ' items...'
			} else {
				this.message = 'Loading list...'
			}
			this.apiCall({ destination: 'get_list_suppliers_inventory', data: this.filters }).then(obj => {
				this.client_id = obj.client_id
				this.loading = false
				this.messageStatus = obj.status
				if (this.filters.do_export) {
					this.message = 'Downloading CSV...'
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = obj.download_url
						this.message = ''
					}, 1500)
				} else {
					this.message = obj.message
					this.list = obj.suppliers
					if (obj.paging) {
						this.paging = obj.paging
					}
				}
			}).catch(err => {
				this.loading = false
				this.messageStatus = 'error'
				this.message = "There was an error loading the list."
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		toggleFilter(which) {
			this.filters.page = 1
			if (which == 'search' || which == 'supplier_type_id') {
				// nothing to do!
			} else {
				this.filters[which] = !this.filters[which]
			}
			this.getList()
		},
		getItem(item) {
			if (this.loading) { return }
			this.loading = true
			this.message = 'Loading supplier...'
			this.apiCall({ destination: 'get_item_supplier_inventory', data: { supplier_id: item.supplier_id } }).then(obj => {
			 	this.loading = false
				this.message = ''
				this.messageStatus = obj.status
			 	if (obj.status == 'success') {
			 		this.listDetail = obj.supplier
					this.detailTotals = obj.totals
					if (obj.received) {
						this.receivedList = obj.received
					}
					if (obj.logbooks_received) {
						this.logbooksReceivedList = obj.logbooks_received
					}
					this.showDetail = true
				} else {
			 		this.message = obj.message
			 	}
			})
		},
		updateSelectedState(state) {
			this.listDetail.state = state
		},
		setMerge(caliber) {
			this.listDetail.merge_into = caliber.caliber_id
			this.filters.merge_search_term = caliber.description
			this.mergeList = []
		},
		addItem() {
			this.listDetail = {
				caliber_id: 'new',
				client_id: this.client_id,
				description: '',
				internal_use_only: 0,
				inactive: 0
			}
			this.userCanEdit = true
			this.showModal = true
		},
		saveItem() {
			if (this.saving) { return }
			if (!this.listDetail.supplier_type_id) {
				this.messageStatus = 'invalid'
				this.message = 'Supplier type is required.'
				return
			}
			if (!this.listDetail.first_name && !this.listDetail.first_name && !this.listDetail.company_name) {
				this.messageStatus = 'invalid'
				this.message = 'First and last name or company name is required.'
				return
			}
			this.saving = true
			this.messageStatus = ''
			this.messageTimeout = 0
			this.message = 'Saving supplier...'
			this.apiCall({ destination: 'save_item_supplier_inventory', data: this.listDetail }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Supplier saved!'
					this.messageTimeout = 1500
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		deactivateSupplier() {
			if (this.saving) { return }
			this.showDeactivateModal = false
			this.saving = true
			this.messageStatus = ''
			this.messageTimeout = 0
			this.message = 'Deactivating supplier...'
			this.apiCall({ destination: 'deactivate_item_supplier_inventory', data: this.listDetail }).then(obj => {
				this.saving = false
				this.messageStatus = obj.status
				if (obj.status == 'success') {
					this.message = 'Supplier deactivated!'
					this.messageTimeout = 1500
					setTimeout(() => {
						this.backToList()
					}, 1500)
				} else {
					this.message = obj.message
				}
			}).catch(err => {
				console.log(err)
			})
		},
		doEZCheck() {
			if (this.saving) { return }
			this.fflEZCheckResult = ''
			this.loading = true
			this.showEZCheckModal = true
			this.apiCall({ destination: 'do_ffl_ez_check', data: { ffl_number: this.listDetail.ffl_number, supplier_id: this.listDetail.supplier_id, contact_id: this.listDetail.contact_id } }).then(obj => {
				this.loading = false
				if (obj.status == 'success') {
					this.fflEZCheckResult = obj.ffl_ezcheck_result
					this.listDetail.ffl_number = obj.ffl_number
					this.listDetail.ffl_date_expires = obj.ffl_date_expires
				} else {
					this.fflEZCheckMessage = obj.message
				}
			})
		},
		backToList() {
			this.listDetail = {}
			this.showDetail = false
			if (this.creatingSupplier) {
				this.cancelNewSupplierFlow()
			} else {
				this.getList()
			}
		},
		doExport() {
			if (this.loading) { return }
			this.messageTimeout = 0
			this.messageStatus = ''
			this.filters.do_export = true
			this.getList()
		}, 
		addSupplier() {
			this.startNewSupplierFlow()
		}, 
		startNewSupplierFlow() {
			this.previousDetail = this.showDetail ? JSON.parse(JSON.stringify(this.listDetail)) : null

			this.creatingSupplier = true
			this.newSupplierDetail = this.initNewSupplierDetail()

			this.syncNewSupplierToDetail()

			this.deatilTotals = {}
			this.receivedList = []
			this.logbooksReceivedList = []

			this.showDetail = true
		}, 
		cancelNewSupplierFlow() {
			this.creatingSupplier = false
			this.newSupplierDetail = null

			if (this.previousDetail) {
				this.listDetail = JSON.parse(JSON.stringify(this.previousDetail))
				this.previousDetail = null
				this.showDetail = true
			} else {
				this.backToList()
			}
		}, 
		syncNewSupplierToDetail() {
			this.listDetail = JSON.parse(JSON.stringify(this.newSupplierDetail))
		}, 
		initNewSupplierDetail() {
			return {
				supplier_id: '', 
				contact_id: '', 
				client_id: this.client_id, 
				supplier_type_id: '', 
				first_name: '', 
				middle_name: '', 
				last_name: '', 
				company_name: '', 
				address_1: '', 
				address_2: '', 
				city: '', 
				state: '', 
				zip_code: '', 
				ffl_number: '', 
				ffl_date_expires: '', 
				internal_use_only: 0, 
				inactive: 0
			}
		}
	}
}
</script>

<style lang="scss" scoped>
</style>
